import { Helmet } from 'react-helmet-async';

const Head = () => {
	const structuredData = {
		'@context': 'http://schema.org',
		'@type': 'Organization',
		name: '중소기업 ERP의 새로운 기준, 스텔라',
		url: 'https://www.stella-erp.co.kr'
	};

	return (
		<Helmet>
			<meta charSet="UTF-8" />
			<meta httpEquiv="X-UA-Compatible" content="IE=edge" />
			<meta httpEquiv="Expires" content="Mon, 06 Jan 1990 00:00:01 GMT" />
			<meta httpEquiv="Expires" content="-1" />
			<meta httpEquiv="Pragma" content="no-cache" />
			<meta httpEquiv="Cache-Control" content="no-cache" />
			<meta
				name="viewport"
				content="width=device-width, initial-scale=1, shrink-to-fit=no viewport-fit=cover user-scalable=no"
			/>
			<link rel="shortcut icon" type="image/x-icon" href="/pc/favicon.ico" />
			<link rel="apple-touch-icon-precomposed" href="/pc/favicon/icon-96x96.png" />
			<link rel="apple-touch-icon" sizes="114x114" href="/pc/favicon/icon-114x114.png" />
			<link rel="apple-touch-icon" href="/pc/favicon/icon-72x72.png" />
			<meta name="apple-mobile-web-app-capable" content="yes" />
			<meta name="format-detection" content="telephone=no" />
			<meta name="format-detection" content="email=no" />
			<script type="application/ld+json">{JSON.stringify(structuredData)}</script>
			<script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-MLQQMZV9');`}</script>

			{/* Google Analytics */}
			<script async src="https://www.googletagmanager.com/gtag/js?id=G-L3PQXKGHG0" />
			<script>
				{`window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', 'G-L3PQXKGHG0');`}
			</script>

			{/* Google Tag Manager */}
			<script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-MRJJ8NP4');`}</script>

			{/*canonical*/}
			<link rel="canonical" href="https://www.stella-erp.co.kr/index.html" />

			{/*SEO*/}
			<meta name="title" content="스타트업/성장기업을 위한 ERP, 스텔라" data-rh="true" />
			<meta name="description" content="스타트업 운영에 필수적인 클라우드 ERP 플랫폼" data-rh="true" />
			<meta
				name="keywords"
				content="스텔라,스텔라,Stella,Stella erp,ERP,ERP프로그램,중소기업ERP,중소기업,스타트업,창업지원,신설기업,창업기업ERP,클라우드ERP, 재무,회계,결산,인사,사원대장,급여,급여명세서,금여대장,금융,통합계좌관리,증빙관리,영수증관리,지출결의서,매입매출관리,세금신고,자금이체,자동전표,미수금관리,전자세금계산서,세금계산서,원천세신고,연말정산,소득세,법인세,스크래핑,문서발행,세무사연계,자동분개,손익보고서,재무재표,경리,경리업무,경리소프트웨어,경리프로그램,경리회계프로그램,경리업무프로그램,경리업무소프트웨어,기장,핑거"
			/>
			<meta name="apple-mobile-web-app-title" content="Stella" />
			<link rel="image_src" href="https://www.stella-erp.co.kr/assets/images/share/share_thumb_1200x630.jpg" />
			{/* FB */}
			<meta property="og:site_name" content="중소기업 ERP의 새로운 기준, 스텔라" />
			<meta property="og:title" content="중소기업 ERP의 새로운 기준, 스텔라" />
			<meta property="og:description" content="중소기업 운영에 필수적인 클라우드 ERP 플랫폼" />
			<meta property="og:type" content="website" />
			<meta property="og:locale" content="kr" />
			<meta property="og:url" content="https://www.stella-erp.co.kr/index.html" />
			<meta property="og:image" content="https://www.stella-erp.co.kr/assets/images/share/share_thumb_1200x630.jpg" />
			<meta property="og:image:width" content="1200" />
			<meta property="og:image:height" content="630" />
		</Helmet>
	);
};

export default Head;
